import React, { useState } from 'react'
import { notify } from '../../utils/utils'

export const useDisenoRuta = () => {
  const [infoRutas, setInfoRutas] = useState([])
  
  const listarRutasATU = async () => {
    const response = await fetch("https://desarrollo-webapi.abexacloud.com/listar-rutas").then(res => res.json())

    if(response.isValid){
      setInfoRutas(response.content)
    }else{
      notify(response.exceptions[0].description, 'error')
    }
  }
  
  return {
    listarRutasATU,
    infoRutas
  }
}
